module.exports = __webpack_public_path__ + "static/media/btn7.3cabd6fa.png";